export default __webpack_public_path__ + "static/top-6b3ef898b8548d90e1e5ae1c2927d51a.jpg";